import { Preferences } from "@capacitor/preferences";
import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";

import { isApp } from "@/functions/enviroment";

import { DISPLAY_MODE } from "@/types/enum/general";
import { DISPLAY_MODE_KEY } from "@/types/enum/storageKeys";
import { EdgeToEdge } from "@capawesome/capacitor-android-edge-to-edge-support";
import { isPlatform } from "@ionic/core";

const setDefaultStyle = async (): Promise<void> => {
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        if (Capacitor.isNativePlatform()) await StatusBar.setStyle({ style: Style.Dark });
        return
    }
    if (Capacitor.isNativePlatform()) await StatusBar.setStyle({ style: Style.Light })
}

const setBodyTheme = (value: string | DISPLAY_MODE): void => {
    switch (value) {
        case DISPLAY_MODE.DARK:
            if (Capacitor.isNativePlatform()) {
                StatusBar.setStyle({ style: Style.Dark });
                if (isPlatform('android')) EdgeToEdge.setBackgroundColor({ color: '#000000' })
            }
            document.documentElement.setAttribute('data-theme', 'dark');
            return;
        case DISPLAY_MODE.LIGHT:
            if (Capacitor.isNativePlatform()) {
                StatusBar.setStyle({ style: Style.Light });
                if (isPlatform('android')) EdgeToEdge.setBackgroundColor({ color: '#ffffff' })
            }
            document.documentElement.setAttribute('data-theme', 'light');
            return;
        default:
            if (Capacitor.isNativePlatform()) setDefaultStyle()
            document.documentElement.setAttribute('data-theme', 'default');
            return;
    }
}

const getDisplayMode = async (): Promise<DISPLAY_MODE> => {
    const value = (await Preferences.get({ key: DISPLAY_MODE_KEY }))?.value

    switch (value) {
        case DISPLAY_MODE.DARK:
            return DISPLAY_MODE.DARK
        case DISPLAY_MODE.LIGHT:
            return DISPLAY_MODE.LIGHT
        case DISPLAY_MODE.DEFAULT:
            return DISPLAY_MODE.DEFAULT
        default:
            return isApp() ? DISPLAY_MODE.DARK : DISPLAY_MODE.LIGHT
    }
}

const loadBodyTheme = async (): Promise<void> => {
    const theme = await getDisplayMode()

    setBodyTheme(theme)
    setVariables();
}

const setStatusBarStyle = async (): Promise<void> => {
    setTimeout(() => {
        StatusBar.setOverlaysWebView({ overlay: true });
    }, 201)
};

const isDark = (): boolean => {
    const dataTheme = document.documentElement.getAttribute('data-theme')

    if (dataTheme === 'light') return false
    if (dataTheme === 'dark') return true

    if (!window) return false
    return window.matchMedia('(prefers-color-scheme: dark)').matches
}

const initSchemeListener = (): void => {
    window.addEventListener('change', loadBodyTheme);
}

const setVariables = () => {
    const isFirefox = /firefox/i.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android|crios|fxios|edg).)*safari/i.test(navigator.userAgent);
    if (!isApp() && (isFirefox || isSafari)) {
        const htmlRoot = document.querySelector(':root') as HTMLElement;
        htmlRoot.style.setProperty('--item-list-max-width', 'calc(100% - 0.75rem)')
    }
}

export {
    getDisplayMode,
    setBodyTheme,
    loadBodyTheme,
    setStatusBarStyle,
    isDark,
    initSchemeListener
}
